import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const regExDes = /^[a-zA-Z0-9][a-zA-Z0-9\s-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]*$/;

class EditTermsandCondition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        termsUrl: this.props.ItemList ? this.props.ItemList.termsUrl : null,
        termsV: this.props.ItemList ? this.props.ItemList.termsV : null,
        privacyUrl: this.props.ItemList ? this.props.ItemList.privacyUrl : null,
        privacyV: this.props.ItemList ? this.props.ItemList.privacyV : null,
        id: this.props.ItemList ? this.props.ItemList.id : null,
        isActive: this.props.ItemList ? this.props.ItemList.isActive : false
      }
    };
    this.onChange = this.onChange.bind(this);
    this.submit = this.submit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  onChange(event) {
    let name = event.target.name;
    let value = event.target.value;
    if (name === "termsUrl") {
      if (value === "" || regExDes.test(value)) {
        this.setState({
          value: { ...this.state.value, termsUrl: value }
        });
        console.log("++++++++++++++++++++++++++++", value);
      }
    } else if (name === "termsV") {
      if (value === "" || regExDes.test(value)) {
        this.setState({
          value: { ...this.state.value, termsV: value }
        });
        console.log("++++++++++++++++++++++++++++", value);
      }
    } else if (name === "privacyUrl") {
      if (value === "" || regExDes.test(value)) {
        this.setState({
          value: { ...this.state.value, privacyUrl: value }
        });
        console.log("++++++++++++++++++++++++++++", value);
      }
    } else if (name === "privacyV") {
      if (value === "" || regExDes.test(value)) {
        this.setState({
          value: { ...this.state.value, privacyV: value }
        });
        console.log("++++++++++++++++++++++++++++", value);
      }
    }
  }
  handleChange(checked) {
    this.setState({ value: { ...this.state.value, isActive: checked } });
  }

  submit() {
    let data = this.state.value;
    console.log("data++++++++++data+++++", data);
    if (
      data.termsUrl !== "" &&
      data.termsV !== "" &&
      data.privacyUrl !== "" &&
      data.privacyV !== ""
    ) {
      this.props.EditTrmsadCndtn(this.state.value);

      this.props.closeEditModel();
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        termsUrl: nextProps.ItemList && nextProps.ItemList.termsUrl,
        termsV: nextProps.ItemList && nextProps.ItemList.termsV,
        privacyUrl: nextProps.ItemList && nextProps.ItemList.privacyUrl,
        privacyV: nextProps.ItemList && nextProps.ItemList.privacyV,
        id: nextProps.ItemList && nextProps.ItemList.id,
        isActive: nextProps.ItemList && nextProps.ItemList.isActive
      }
    });
  }
  render() {
    return (
      <div>
        <Modal
          show={this.props.showTrmsadCndtnEditModel}
          onHide={this.props.closeEditModel}
          animation={false}
          size="lg"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>
              <span style={{ fontSize: "20px" }}>Terms & Conditions</span>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Container>
              <Form>
                <Row>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group controlId="termsUrl">
                      <Form.Label>Terms Url</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="termsUrl"
                        onChange={this.onChange}
                        value={this.state.value.termsUrl}
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group controlId="termsV">
                      <Form.Label>Terms Version</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="termsV"
                        value={this.state.value.termsV}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group controlId="privacyUrl">
                      <Form.Label>Privacy Url</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="privacyUrl"
                        onChange={this.onChange}
                        value={this.state.value.privacyUrl}
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group controlId="privacyV">
                      <Form.Label>Privacy Version</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="privacyV"
                        value={this.state.value.privacyV}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} sm={12} xs={12}>
                    <div style={{ display: "flex" }}>
                      <label style={{ display: "flex", marginTop: "8px" }}>
                        <div style={{ marginRight: "30px" }}>
                          <span>Active</span>
                        </div>
                        <div style={{ marginTop: "-5px" }}>
                          <Switch
                            onChange={this.handleChange}
                            onColor="#20a8d8"
                            checked={
                              this.state.value.isActive
                                ? this.state.value.isActive
                                : false
                            }
                          />
                        </div>
                      </label>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditTermsandCondition;
